// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__rVPYg","large":"styles_large__3-tWI"};